<!-- Título, trilha e "Voltar" só na visão do dev: na de administração este componente é
     filho do AdminShellComponent, que já abre o po-page-default com título e abas. Ver
     `pageTitle` no componente. -->
<po-page-default
  [p-title]="pageTitle"
  [p-breadcrumb]="breadcrumb"
  [p-actions]="pageActions">

  <!-- Período, tipo, origem, área e usuário: mesmo recorte-linha-só do Painel de
       Custos (ver costs-panel.component.html) — os cinco campos cabem no grid do PO
       sem layout próprio. -->
  <div class="po-row">
    <app-period-filter
      [inline]="true"
      presetClass="po-sm-12 po-md-4 po-lg-3"
      rangeClass="po-sm-12 po-md-8 po-lg-4"
      [period]="period"
      (periodChange)="onPeriodChange($event)">
    </app-period-filter>

    <po-multiselect
      name="dashboardResourceType"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Tipo de review"
      p-placeholder="Todos os tipos"
      p-filter-mode="contains"
      [p-options]="resourceTypeOptions"
      [ngModel]="selectedResourceTypes"
      (ngModelChange)="onResourceTypeChange($event)">
    </po-multiselect>

    <po-multiselect
      name="dashboardSourceProvider"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Origem"
      p-placeholder="Todas as origens"
      p-filter-mode="contains"
      [p-options]="sourceProviderOptions"
      [ngModel]="selectedSourceProviders"
      (ngModelChange)="onSourceProviderChange($event)">
    </po-multiselect>

    <!-- Área e usuário recortam o trabalho DE OUTRAS PESSOAS: dentro do escopo do dev os
         dois filtram sempre para ele mesmo, e um filtro que não muda nada é ruído. -->
    <po-multiselect
      *ngIf="isServiceView"
      name="dashboardArea"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Área"
      p-placeholder="Todas as áreas"
      p-filter-mode="contains"
      [p-options]="areaOptions"
      [ngModel]="selectedAreas"
      (ngModelChange)="onAreaChange($event)">
    </po-multiselect>

    <po-multiselect
      *ngIf="isServiceView"
      name="dashboardUser"
      class="po-sm-12 po-md-4 po-lg-3"
      p-label="Usuário"
      p-placeholder="Todos os usuários"
      p-filter-mode="contains"
      [p-options]="userOptions"
      [ngModel]="selectedUsers"
      (ngModelChange)="onUserChange($event)">
    </po-multiselect>
  </div>

  <po-loading-overlay *ngIf="loading" p-size="md" p-text="Carregando"></po-loading-overlay>

  <ng-container *ngIf="!loading">

    <!-- Operação agora: um po-widget por estado do job, com a tag dizendo o que exige
         alguém (DLQ) e o que se resolve sozinho (retentativa). Vem primeiro na
         visão de serviço — antes dos números, se o pipeline está entregando. As causas das
         falhas ficam recolhidas e abrem sozinhas quando há algo na DLQ. -->
    <section class="review-health" *ngIf="serviceHealth as health" aria-label="Operação do serviço">
      <div class="review-section__head">
        <span class="po-icon po-icon-server review-section__icon" aria-hidden="true"></span>
        <h2 class="po-font-subtitle review-section__title">Operação agora</h2>
        <po-tag *ngIf="healthAllClear" p-value="Em dia" p-type="success" p-inverse="true"></po-tag>
        <span class="po-font-text-small review-section__hint">Estado da fila neste momento — não segue os filtros.</span>
      </div>
      <po-divider class="review-section__divider"></po-divider>

      <div class="review-health__tiles">
        <po-widget *ngFor="let tile of healthTiles; trackBy: trackByLabel" class="review-health__tile" [p-title]="tile.label">
          <p class="po-font-title review-health__value"
            [class.review-health__value--idle]="!tile.tag">{{ tile.value }}<span
            class="po-icon po-icon-info review-health__help" [p-tooltip]="tile.help"
            p-tooltip-position="bottom" p-append-in-body="true"></span></p>
          <po-tag *ngIf="tile.tag" [p-value]="tile.tag" [p-type]="tile.state" p-inverse="true"></po-tag>
          <p class="po-font-text-small review-health__hint">{{ tile.hint }}</p>
        </po-widget>
      </div>

      <po-accordion *ngIf="health.topErrors?.length" class="review-health__causes">
        <po-accordion-item #failureCauses
          [p-label]="failureCausesLabel"
          [p-label-tag]="failureCausesTag.label"
          [p-type-tag]="failureCausesTag.type">
          <app-review-stats-health-errors [errors]="health.topErrors" [showHeading]="false">
          </app-review-stats-health-errors>
        </po-accordion-item>
      </po-accordion>
    </section>

    <!-- Seções: na visão de serviço separam "agora" (a fila, fora dos filtros) de "no
         período" (tudo que os filtros recortam) — sem o corte o leitor procuraria o efeito
         do filtro na fila. Na do dev, que não tem a fila, as mesmas seções separam o que
         ele mede do que ele tem a corrigir: a mesma tela, com o mesmo mapa. -->
    <div class="review-section__head">
      <span class="po-icon po-icon-chart-columns review-section__icon" aria-hidden="true"></span>
      <h2 class="po-font-subtitle review-section__title">No período</h2>
      <span class="po-font-text-small review-section__hint">{{ periodSectionHint }}</span>
    </div>
    <po-divider class="review-section__divider"></po-divider>

    <!-- Com visão global, a visão pessoal mostra o recorte da lista de reviews: todas as
         áreas e pessoas. Dizer isso evita ler os números como "os meus". -->
    <p class="po-font-text-small review-dashboard__scope-note" *ngIf="showsEveryonesReviews">
      <span class="po-icon po-icon-info" aria-hidden="true"></span>
      Você vê os reviews de todas as áreas e pessoas, como na lista de reviews.
    </p>

    <app-review-stats-kpis
      [stats]="stats"
      [previous]="previousStats"
      [serviceView]="isServiceView"
      [falsePositive]="falsePositive">
    </app-review-stats-kpis>

    <!-- Qualidade: severidade e veredito valem para as duas audiências, e o terceiro card
         diz se dá para confiar neles — a calibragem do time na visão de serviço (lida do
         Painel de Curadoria), o feedback do próprio usuário na do dev. Mesmo desenho nos
         dois, com populações diferentes. -->
    <div class="po-row review-dashboard__quality" *ngIf="hasDetailedResults || hasSideQualityCard">
      <app-review-stats-severity *ngIf="hasDetailedResults"
        [ngClass]="hasSideQualityCard ? 'po-md-8' : 'po-md-12'" [stats]="stats" [previous]="previousStats">
      </app-review-stats-severity>
      <po-widget *ngIf="isServiceView" [ngClass]="hasDetailedResults ? 'po-md-4' : 'po-md-12'" p-title="Calibragem">
        <app-review-stats-calibration [dateFrom]="period.dateFrom" [dateTo]="period.dateTo"
          [periodPreset]="period.preset" [sourceProviders]="selectedSourceProviders"
          [areas]="selectedAreas" [users]="selectedUsers" [resourceTypes]="selectedResourceTypes"
          (loaded)="onCalibrationLoaded($event)">
        </app-review-stats-calibration>
      </po-widget>
      <po-widget *ngIf="!isServiceView && stats?.feedback" [ngClass]="hasDetailedResults ? 'po-md-4' : 'po-md-12'"
        p-title="Seu feedback">
        <app-review-stats-feedback [stats]="stats"></app-review-stats-feedback>
      </po-widget>
    </div>

    <!-- Um aviso só, no lugar dos sete recortes vazios. Ver `isEmptyPeriod`. -->
    <div class="po-row" *ngIf="isEmptyPeriod">
      <po-widget class="po-md-12">
        <p class="po-font-text">Nenhum review neste recorte.</p>
        <p class="po-font-text-small">
          Amplie o período ou remova filtros — os recortes voltam assim que houver ao menos
          um review.
        </p>
      </po-widget>
    </div>

    <!-- Só chega preenchido para quem tem `smartreview.admin` (ou `superuser`) — a
         ausência do campo na resposta é a autoridade real; o `*ngIf` aqui só decide a
         UI, mesmo padrão do bloco `health` mais abaixo. -->
    <div class="po-row" *ngIf="stats?.series && !isEmptyPeriod">
      <po-widget class="po-md-12" p-title="Demanda e reviews com achados">
        <app-review-stats-timeseries-chart
          [points]="stats?.series ?? []"
          [period]="period">
        </app-review-stats-timeseries-chart>
      </po-widget>
    </div>

    <ng-container *ngIf="!isEmptyPeriod">

    <!-- Adoção num card só, com abas: cinco recortes em cinco cards ocupavam três linhas e
         diziam a mesma coisa de cinco jeitos. Área primeiro — é por ela que a adoção anda. -->
    <div class="po-row" *ngIf="isServiceView">
      <po-widget class="po-md-12" p-title="Adoção">
        <po-tabs>
          <po-tab p-label="Área" [p-active]="true">
            <app-review-stats-breakdown keyLabel="Área" [rows]="areaRows" [totalKeys]="keysOf('area')"
              [labelFn]="areaLabel"></app-review-stats-breakdown>
          </po-tab>
          <po-tab p-label="Usuário">
            <app-review-stats-breakdown keyLabel="Usuário" [rows]="userRows"
              [totalKeys]="keysOf('user')"></app-review-stats-breakdown>
          </po-tab>
          <po-tab p-label="Tipo de review">
            <app-review-stats-breakdown keyLabel="Tipo de review" [rows]="resourceTypeRows"
              [totalKeys]="keysOf('resourceType')" [labelFn]="resourceTypeLabelFn"></app-review-stats-breakdown>
          </po-tab>
          <po-tab p-label="Origem">
            <app-review-stats-breakdown keyLabel="Origem" [rows]="sourceProviderRows"
              [totalKeys]="keysOf('sourceProvider')" [labelFn]="sourceProviderLabelFn"></app-review-stats-breakdown>
          </po-tab>
          <!-- language é a única dimensão multi-valorada: a soma das fatias pode passar de
               totals.total (um review com arquivos em duas linguagens conta em cada uma). -->
          <po-tab p-label="Linguagem">
            <app-review-stats-breakdown keyLabel="Linguagem" [rows]="languageRows"
              [totalKeys]="keysOf('language')"></app-review-stats-breakdown>
          </po-tab>
        </po-tabs>
      </po-widget>
    </div>

    <div class="review-section__head">
      <span class="po-icon po-icon-target review-section__icon" aria-hidden="true"></span>
      <h2 class="po-font-subtitle review-section__title">O que corrigir</h2>
      <span class="po-font-text-small review-section__hint">Os reviews e os fontes que mais pedem ação.</span>
    </div>
    <po-divider class="review-section__divider"></po-divider>

    <!-- O que corrigir: a unidade é o review, não o arquivo agregado do ranking. Na visão
         de serviço, a lista é a do time inteiro. -->
    <div class="po-row">
      <po-widget class="po-md-12" p-title="Reviews que pedem ação">
        <app-review-stats-attention-summary [filters]="hotspotFilters"></app-review-stats-attention-summary>
      </po-widget>
    </div>

    <div class="po-row">
      <!-- O ranking usa uma rota própria: pesquisa e paginação acontecem no banco sem
           recalcular os demais KPIs do dashboard. -->
      <po-widget class="po-md-12" p-title="Ranking de fontes que exigem atenção">
        <app-review-stats-hotspots-summary [filters]="hotspotFilters"></app-review-stats-hotspots-summary>
      </po-widget>
    </div>

    </ng-container>

  </ng-container>

</po-page-default>

<notificationComponentHM></notificationComponentHM>
